export default __webpack_public_path__ + "static/media/counter-pos.f0850f1f.svg";